<template>
    <Fragment>
        <div v-if="item" class="row catalog_item">
            <div class="col-12 col-lg-3 mt_md">
                <div class="ci_g item_gallery">
                    <div class="item_preview tab-content">
                        <div class="item_icon item_icon_topleft">

                            <template v-if="part">
                                <div
                                    v-if="part == 'A'"
                                    class="cg_i item_icon item_icon_left"
                                >
                                    <img src="/i/a.svg" alt="Часть A" />
                                </div>
                                <div
                                    v-if="part == 'B'"
                                    class="cg_i item_icon item_icon_left"
                                >
                                    <img src="/i/b.svg" alt="Часть B" />
                                </div>
                                <div
                                    v-if="part == 'C'"
                                    class="cg_i item_icon item_icon_left"
                                >
                                    <img src="/i/c.svg" alt="Часть C" />
                                </div>
                                <div
                                    v-if="part == 'D'"
                                    class="cg_i item_icon item_icon_left"
                                >
                                    <img src="/i/d.svg" alt="Часть D" />
                                </div>
                            </template>

                        </div>

                        <template v-if="item.images && item.images.length">
                            <template v-for="(image, index) in item.images">
                                <div :class="'ci_p tab-pane' + (index == 0 ? ' active' : '')" :id="'s_' + image.item_id + '_' + image.id">
                                    <div class="item_picture">
                                        <a :href="'/storage/' + image.path" class="glightbox" :data-gallery="'p' + image.item_id">
                                            <div :style="'background-image: url(/storage/' + image.path + ')'" class="zoom"></div>
                                        </a>
                                    </div>
                                </div>
                            </template>
                        </template>
                        <template v-else>
                            <div class="ci_p tab-pane active">
                                <div class="item_picture">
                                    <span>
                                        <div style="" class="zoom"></div>
                                    </span>
                                </div>
                            </div>
                        </template>

                    </div>
                    <ul class="item_thumbs nav">

                        <template v-if="item.images && item.images.length">
                            <template v-for="(image, index) in item.images">
                                <li class="ci_t">
                                    <a :href="'#s_' + image.item_id + '_' + image.id" data-toggle="tab" class="">
                                        <div class="item_picture">
                                            <div :style="'background-image: url(/storage/' + image.path + ')'"></div>
                                        </div>
                                    </a>
                                </li>
                            </template>
                        </template>

                    </ul>
                </div>
            </div>
            <div class="col-12 col-lg-9 mt_md">
                <div v-if="color && color.length" class="ci_change">
                    <div>
                        <button
                            data-toggle="modal"
                            :data-target="'#modal_color_' + item.id"
                            class="btn btn_sm btn_neutral btn_icontext"
                        >
                            <i class="f7-icons icon_sm">paintbrush</i> Выбрать
                            другой цвет
                        </button>
                    </div>
                </div>

                <h3 class="ci_title subtitle">{{ item.full_title }}</h3>

                <div class="ci_info item_info">
                    <p v-if="item.attr_color"><span>Цвет</span> {{ item.attr_color }}</p>
                    <p v-if="item.attr_size"><span>Размер</span> {{ item.attr_size }}</p>
                    <p v-if="item.attr_material"><span>Материал</span> {{ item.attr_material }}</p>
                    <p v-if="item.attr_type"><span>Тип</span> {{ item.attr_type }}</p>
                    <p v-if="item.country"><span>Производитель</span> {{ item.country }}</p>
                    <p v-if="item.attr_other"><span>Прочее</span> {{ item.attr_other }}</p>
                    <p v-if="item.sku"><span>Артикул</span> {{ item.sku }}</p>
                </div>

                <div class="ci_about"></div>
                <ul class="ci_price item_price list-group list-group-horizontal-md">
                    <li class="list-group-item mt_xs">
                        <div class="price_lg">{{ item.price }} р. за {{ item.unit }}</div>
                        <div class="small_info">
                            В упаковке по <span class="accent">{{ item.qty_per_pack }} {{ item.unit }}</span>
                        </div>
                    </li>
                    <li class="list-group-item mt_xs">
                        <div class="price_lg">{{ item.price_for_pack }} р. за уп.</div>
                        <div class="small_info">
                            По сумме заказа –
                            <a href="/discounts">скидки</a>
                        </div>
                    </li>
                    <li class="list-group-item mt_xs">
                        <span v-if="item.status == 1" class="stock_lg">В наличии.</span>
                        <span v-else-if="item.status == 3" class="stock_some_xs">Заканчивается.</span>
                        <span v-else-if="item.status == 2" class="stock_gone_lg">Нет в наличии.</span>
                        <span v-else-if="item.status == 4" class="stock_gone_lg">Под заказ.</span>
                        <span v-else class="stock_gone_lg">Нет в наличии.</span>

                        <div class="small_info">
                            Условия
                            <a href="/conditions">работы и доставки</a>
                        </div>
                    </li>
                </ul>
                <div class="ci_action form-inline clearfix">

                    <cart-add-big-button v-if="item.status == 1 || item.status == 3"
                        :id="item.id" :qty_per_pack="item.qty_per_pack"
                        :qty_in_stock="item.qty_in_stock"></cart-add-big-button>

                    <template v-else>
                        <inform-button :id="item.id"></inform-button>

                        <inform-modal v-if="isAuth" :id="item.id" :email="email"></inform-modal>
                        <inform-modal v-else :id="item.id"></inform-modal>

                        <inform-unsubscribe-modal :id="item.id"></inform-unsubscribe-modal>
                    </template>

                    <favourites-add-big-button v-if="isAuth" :id="item.id"></favourites-add-big-button>

                </div>
            </div>
        </div>

        <template v-if="item">
            <catalog-set-modal-related
                v-if="color"
                :modalId="'modal_color_' + item.id"
                title='Выбор цвета'
                :items='color'
                titleAttr='attr_color'
                v-on:click:item="chooseItem($event)"
            ></catalog-set-modal-related>

            <catalog-set-modal-related
                v-if="size"
                :modalId="'modal_size_' + item.id"
                title='Выбор размера'
                :items='size'
                titleAttr='attr_size'
                :chooseItem='chooseItem'
            ></catalog-set-modal-related>
        </template>
    </Fragment>
</template>


<script>
import { Fragment } from "vue-fragment";

export default {
    props: ['id', 'part', 'itemdata'],

    components: { Fragment },

    data: function () {
        return {
            item: this.itemdata,
            color: [],
            size: [],
        };
    },

    methods: {
        chooseItem: function (item) {
            this.item = item;

            let params = {}

            params[this.part] = this.item;

            this.$store.dispatch("set/setItem", params);
        }
    },
    computed: {
        isAuth() {
            return this.$store.state.isAuth;
        },

        email() {
            return this.$store.state.email;
        },
    },
    mounted() {
        let params = {}

        params[this.part] = this.item;

        this.$store.dispatch("set/setItem", params);



        axios.get("/ajax/catalog/related/" + this.id).then((request) => {
            if (
                typeof request.data.success != "undefined" &&
                request.data.success
            ) {
                this.color = request.data.data.color;
                this.size = request.data.data.size;

                console.log(this.color, this.size);
            }
        });
    }
};
</script>
